/**
 * calendarDay.ts — a contract closes on a calendar day (the IDL's `plainDate`), spelled
 * `YYYY-MM-DD`. The exact deadline, when there is one, lives beside it, never in it.
 * Twin of server/lib/calendarDay.js.
 */

const DAY = /^\d{4}-\d{2}-\d{2}$/;

/** `value` when it is a real calendar day spelled `YYYY-MM-DD`, else null: an instant, a
 *  padded or partial string, or an impossible date like 2026-02-30 is not one. */
export function calendarDay(value: unknown): string | null {
  if (typeof value !== "string" || !DAY.test(value)) return null;
  const midnight = new Date(`${value}T00:00:00.000Z`);
  return !Number.isNaN(midnight.getTime()) && midnight.toISOString().slice(0, 10) === value
    ? value
    : null;
}
